import { Link, useLocation } from "react-router-dom";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { ViewTypes } from "../../shared/MembersList/CommunityMembers/ListView/CommunityMember/MemberActions";
import { useSelectMembersInfiniteQuery } from "../../shared/MembersList/CommunityMembers/hooks/useSelectMembersInfiniteQuery";
import { Typography } from "../../shared/uikit/Typography";
import { useConnectionsCount } from "../useConnectionsCount";
import { useMemberDirectorySettings } from "../useMemberDirectorySettings";

const i18nBase = "members_directory.left_side_profile_navigation";

export const MobileNavigationTabs = () => {
  const { pathname } = useLocation();
  const memberDirectorySettings = useMemberDirectorySettings();

  const isAllMembersActive = pathname === "/members";
  const isMyConnectionsActive = pathname === "/members/connections";

  const { totalMembers } = useSelectMembersInfiniteQuery({
    defaultSort: memberDirectorySettings.defaultSort,
    scopeResults: memberDirectorySettings.scope,
    viewType: ViewTypes.MEMBER_DIRECTORY,
  });

  const { connectionsCount } = useConnectionsCount();

  return (
    <div className="border-primary mx-2 mb-4 flex gap-6 border-b px-5 md:hidden">
      <Link
        to="/members"
        className={classNames(
          "flex h-12 flex-1 items-center justify-center gap-2 border-b-2 px-4 transition-colors",
          isAllMembersActive
            ? "border-darkest"
            : "hover:border-primary border-transparent",
        )}
      >
        <Typography.LabelMd
          weight={isAllMembersActive ? "semibold" : "medium"}
          color={isAllMembersActive ? "text-dark" : "text-light"}
        >
          {t(`${i18nBase}.all_members`)}
        </Typography.LabelMd>
        <Typography.LabelMd
          weight={isAllMembersActive ? "semibold" : "normal"}
          color="text-light"
        >
          {totalMembers}
        </Typography.LabelMd>
      </Link>

      <Link
        to="/members/connections"
        className={classNames(
          "flex h-12 flex-1 items-center justify-center gap-2 border-b-2 px-4 transition-colors",
          isMyConnectionsActive
            ? "border-darkest"
            : "hover:border-primary border-transparent",
        )}
      >
        <Typography.LabelMd
          weight={isMyConnectionsActive ? "semibold" : "medium"}
          color={isMyConnectionsActive ? "text-dark" : "text-light"}
        >
          {t(`${i18nBase}.my_connections`)}
        </Typography.LabelMd>
        <Typography.LabelMd
          weight={isMyConnectionsActive ? "semibold" : "normal"}
          color="text-light"
        >
          {connectionsCount}
        </Typography.LabelMd>
      </Link>
    </div>
  );
};
